<template>
    <credits></credits>
</template>

<script>
import Credits from '@/components/Credits'
export default {
    components: {
        Credits
    }
}
</script>